/* ═══════════════════════════════════════════════════════
   BEAUTYFULL COSMETICS — JS GLOBAL 2026
   Version : 1.0.0 | Compatible Dawn 15.4.1
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ───── UTILS ───── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const debounce = (fn, wait = 300) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  const formatMoney = (cents) => {
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  };

  /* ═══════════════════════════════════════════════════════
     1. SHIPPING BAR (panier — barre livraison offerte)
     ═══════════════════════════════════════════════════════ */
  const FREE_SHIPPING_THRESHOLD = 10000; // 100,00€ en centimes

  function updateShippingBar() {
    const bar = $('.bf-shipping-bar');
    if (!bar) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        const total = cart.total_price;
        const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
        const percent = Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100);

        const fill = bar.querySelector('.bf-shipping-bar-fill');
        const text = bar.querySelector('.bf-shipping-bar-text');

        if (fill) fill.style.width = percent + '%';

        if (text) {
          if (remaining === 0) {
            bar.classList.add('is-success');
            text.innerHTML = '✓ Livraison <strong>OFFERTE</strong> débloquée !';
          } else {
            bar.classList.remove('is-success');
            text.innerHTML = `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison offerte`;
          }
        }

        // Mise à jour badge panier dans header
        const cartBadges = $$('.bf-cart-badge, [data-cart-count]');
        cartBadges.forEach(badge => {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(err => console.warn('[Beautyfull] Cart fetch failed:', err));
  }

  /* ═══ 2. CART DRAWER (FIX 1.0 — Délégation événements robuste) ═══ */
  function initCartDrawer() {
    const drawer = document.querySelector('.bf-drawer');
    const overlay = document.querySelector('.bf-drawer-overlay');

    if (!drawer || !overlay) {
      console.warn('[Beautyfull] Cart drawer not found in DOM. Vérifier que {% section "cart-drawer" %} est bien dans theme.liquid');
      return;
    }

    const open = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
      const focusable = drawer.querySelector('button, a, input');
      if (focusable) setTimeout(() => focusable.focus(), 300);
      refreshCartDrawer();
    };

    const close = (e) => {
      if (e) e.preventDefault();
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
    };

    // ═══ DÉLÉGATION D'ÉVÉNEMENTS (capture tous les clics, même dynamiques) ═══
    document.addEventListener('click', (e) => {
      // Ouvrir le drawer
      const openTrigger = e.target.closest('[data-bf-cart-open], .bf-cart-btn');
      if (openTrigger && !openTrigger.closest('.bf-drawer')) {
        open(e);
        return;
      }

      // Lien vers /cart → ouvre le drawer aussi
      const cartLink = e.target.closest('a[href="/cart"], a[href*="/cart?"]');
      if (cartLink && !cartLink.closest('.bf-drawer')) {
        open(e);
        return;
      }

      // Fermer le drawer
      const closeTrigger = e.target.closest('[data-bf-cart-close], .bf-drawer-close');
      if (closeTrigger) {
        close(e);
        return;
      }

      // Fermer en cliquant sur l'overlay
      if (e.target === overlay || e.target.classList.contains('bf-drawer-overlay')) {
        close(e);
      }
    });

    // Échap pour fermer
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // Exposer globalement pour debug et autres scripts
    window.bfCartOpen = open;
    window.bfCartClose = close;

    console.log('[Beautyfull] Cart drawer initialized ✓ — Cliquer sur .bf-cart-btn pour ouvrir');
  }
/* ═══════════════════════════════════════════════════════
     3. CART DRAWER REFRESH (FIX 3.0 — Reconstruction côté JS)
     ═══════════════════════════════════════════════════════ */
  function refreshCartDrawer() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        renderCartDrawer(cart);
        updateCartBadges(cart);
        return cart;
      })
      .catch(err => {
        console.warn('[Beautyfull] Cart fetch failed:', err);
      });
  }

function updateCartBadges(cart) {
    const badges = document.querySelectorAll('.bf-cart-badge, [data-cart-count]');
    badges.forEach(b => {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? '' : 'none';
    });
    // Mettre à jour le compteur dans le titre du drawer
    const drawerTitleCount = document.querySelector('.bf-drawer-title span');
    if (drawerTitleCount) {
      drawerTitleCount.textContent = '(' + cart.item_count + ')';
    }
  }

  function renderCartDrawer(cart) {
    const drawer = document.querySelector('.bf-drawer');
    if (!drawer) return;

    const body = drawer.querySelector('.bf-drawer-body');
    const footer = drawer.querySelector('.bf-drawer-footer');
    if (!body) return;

    // ═══ PANIER VIDE ═══
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="bf-cart-empty">
          <div class="bf-cart-empty-icon">∅</div>
          <h3 class="bf-cart-empty-title">Votre panier est vide</h3>
          <p class="bf-cart-empty-text">Découvrez nos soins naturels pour cheveux texturés.</p>
          <a href="/collections/all" class="bf-btn bf-btn-primary" data-bf-cart-close>
            Découvrir les produits →
          </a>
        </div>
      `;
      // Cacher le footer si panier vide
      if (footer) footer.style.display = 'none';
      // Mise à jour shipping bar
      updateShippingBarFromCart(cart);
      return;
    }

    // ═══ PANIER AVEC ITEMS ═══
    let itemsHTML = '';

    cart.items.forEach(item => {
      const imgUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/\.(jpg|jpeg|png|webp)/i, '_120x.$1')
        : '';

      const variantText = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="bf-cart-item-meta">${escapeHtml(item.variant_title)}</div>`
        : '';

      itemsHTML += `
        <div class="bf-cart-item" data-line-key="${item.key}">
          <a href="${item.url}" class="bf-cart-item-img">
            ${imgUrl ? `<img src="${imgUrl}" alt="${escapeHtml(item.product_title)}" loading="lazy" width="80" height="80">` : ''}
          </a>
          <div class="bf-cart-item-details">
            <a href="${item.url}" class="bf-cart-item-name">${escapeHtml(item.product_title)}</a>
            ${variantText}
            <div class="bf-cart-item-price">${formatMoney(item.final_line_price)}</div>
            <div class="bf-cart-item-actions">
              <div class="bf-qty">
                <button type="button" data-action="minus" aria-label="Diminuer">−</button>
                <input type="number" value="${item.quantity}" min="0" data-key="${item.key}" aria-label="Quantité">
                <button type="button" data-action="plus" aria-label="Augmenter">+</button>
              </div>
              <button type="button" class="bf-cart-remove" data-key="${item.key}" aria-label="Retirer">Retirer</button>
            </div>
          </div>
        </div>
      `;
    });

    // ═══ UPSELL INTELLIGENT ═══
    const upsellHandles = ['nuage-de-boucles', 'calin-reparateur', 'spray-brume', 'peigne-demelant'];
    const cartHandles = cart.items.map(i => i.handle);
    const upsellHandle = upsellHandles.find(h => !cartHandles.includes(h));
    let upsellHTML = '';
    if (upsellHandle) {
      // On va chercher le produit asynchroniquement, mais on prépare un placeholder
      upsellHTML = `<div class="bf-cart-upsell-placeholder" data-handle="${upsellHandle}"></div>`;
    }

    body.innerHTML = itemsHTML + upsellHTML;

    // Charger l'upsell asynchroniquement
    if (upsellHandle) {
      fetch(`/products/${upsellHandle}.js`)
        .then(r => r.json())
        .then(product => {
          const placeholder = body.querySelector(`.bf-cart-upsell-placeholder[data-handle="${upsellHandle}"]`);
          if (!placeholder) return;
          const variant = product.variants[0];
          if (!variant) return;

          placeholder.outerHTML = `
            <div class="bf-cart-upsell">
              <span class="bf-cart-upsell-tag">⭐ + Souvent ajouté</span>
              <p class="bf-cart-upsell-title">Complétez votre routine</p>
              <div class="bf-cart-upsell-product">
                <a href="/products/${product.handle}" class="bf-cart-upsell-img">
                  ${product.featured_image ? `<img src="${product.featured_image}" alt="${escapeHtml(product.title)}" loading="lazy" width="56" height="56">` : ''}
                </a>
                <div class="bf-cart-upsell-info">
                  <h4 class="bf-cart-upsell-name">${escapeHtml(product.title)}</h4>
                  <span class="bf-cart-upsell-price">${formatMoney(variant.price)}</span>
                </div>
                <button type="button" class="bf-cart-upsell-btn" onclick="bfAddUpsell(${variant.id}, this)">+ Ajouter</button>
              </div>
            </div>
          `;
        })
        .catch(() => {
          // Si erreur, on retire juste le placeholder
          const placeholder = body.querySelector('.bf-cart-upsell-placeholder');
          if (placeholder) placeholder.remove();
        });
    }

    // ═══ FOOTER ═══
    if (footer) {
      footer.style.display = '';
      const totalEl = footer.querySelector('.bf-drawer-totals-value, [data-cart-total]');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }

    // Update shipping bar
    updateShippingBarFromCart(cart);

    // Re-attacher les events
    attachCartItemEvents();
  }

  function updateShippingBarFromCart(cart) {
    const bar = document.querySelector('.bf-shipping-bar');
    if (!bar) return;

    const total = cart.total_price;
    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);
    const percent = Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100);

    const fill = bar.querySelector('.bf-shipping-bar-fill');
    const text = bar.querySelector('.bf-shipping-bar-text');

    if (fill) fill.style.width = percent + '%';
    if (text) {
      if (remaining === 0) {
        bar.classList.add('is-success');
        text.innerHTML = '✓ Livraison <strong>OFFERTE</strong> débloquée !';
      } else {
        bar.classList.remove('is-success');
        text.innerHTML = `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison offerte`;
      }
    }
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /* ═══════════════════════════════════════════════════════
     4. CART ITEMS (FIX 3.0 — animation + reset listeners)
     ═══════════════════════════════════════════════════════ */
  function attachCartItemEvents() {
    // Reset listeners (clone pour éviter accumulation)
    document.querySelectorAll('.bf-qty button[data-action="plus"]').forEach(btn => {
      btn.replaceWith(btn.cloneNode(true));
    });
    document.querySelectorAll('.bf-qty button[data-action="plus"]').forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('input');
        const newQty = parseInt(input.value) + 1;
        const key = input.dataset.key;
        if (key) updateCartItem(key, newQty);
      });
    });

    document.querySelectorAll('.bf-qty button[data-action="minus"]').forEach(btn => {
      btn.replaceWith(btn.cloneNode(true));
    });
    document.querySelectorAll('.bf-qty button[data-action="minus"]').forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.parentElement.querySelector('input');
        const currentQty = parseInt(input.value);
        const newQty = Math.max(0, currentQty - 1);
        const key = input.dataset.key;
        if (!key) return;

        // Si on passe à 0, animation slide-out
        if (newQty === 0) {
          const cartItem = this.closest('.bf-cart-item');
          if (cartItem) animateRemoveItem(cartItem);
          this.disabled = true;
          setTimeout(() => updateCartItem(key, 0), 250);
        } else {
          updateCartItem(key, newQty);
        }
      });
    });

    document.querySelectorAll('.bf-qty input').forEach(input => {
      input.replaceWith(input.cloneNode(true));
    });
    document.querySelectorAll('.bf-qty input').forEach(input => {
      input.addEventListener('change', function() {
        const newQty = Math.max(0, parseInt(this.value) || 0);
        const key = this.dataset.key;
        if (!key) return;
        if (newQty === 0) {
          const cartItem = this.closest('.bf-cart-item');
          if (cartItem) animateRemoveItem(cartItem);
          setTimeout(() => updateCartItem(key, 0), 250);
        } else {
          updateCartItem(key, newQty);
        }
      });
    });

    // Bouton Retirer (avec animation)
    document.querySelectorAll('.bf-cart-remove').forEach(btn => {
      btn.replaceWith(btn.cloneNode(true));
    });
    document.querySelectorAll('.bf-cart-remove').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const key = this.dataset.key;
        if (!key) return;

        const cartItem = this.closest('.bf-cart-item');
        if (cartItem) animateRemoveItem(cartItem);

        this.disabled = true;
        this.style.pointerEvents = 'none';

        setTimeout(() => updateCartItem(key, 0), 250);
      });
    });
  }

  function animateRemoveItem(cartItem) {
    cartItem.style.transition = 'opacity .3s ease, transform .3s ease, max-height .3s ease, padding .3s ease, margin .3s ease';
    cartItem.style.opacity = '0';
    cartItem.style.transform = 'translateX(40px)';
    cartItem.style.maxHeight = '0';
    cartItem.style.padding = '0';
    cartItem.style.margin = '0';
    cartItem.style.overflow = 'hidden';
  }

  function updateCartItem(key, quantity) {
    const drawer = document.querySelector('.bf-drawer');

    // Loading visuel léger (pas de blocage complet)
    if (drawer) {
      drawer.style.transition = 'opacity .15s ease';
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(cart => {
      // Re-render le drawer avec les nouvelles données
      renderCartDrawer(cart);
      updateCartBadges(cart);

      // Toast feedback
      if (quantity === 0) {
        bfToast('✓ Produit retiré du panier', 'success');
      } else {
        bfToast('Panier mis à jour', 'success');
      }
    })
    .catch(err => {
      console.error('[Beautyfull] Update cart failed:', err);
      bfToast('Erreur, réessayez', 'error');
    });
  }
  /* ═══════════════════════════════════════════════════════
     5. ADD TO CART (FIX 3.0 — refresh drawer après ajout)
     ═══════════════════════════════════════════════════════ */
  function initAddToCart() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form.matches('form[action*="/cart/add"], form[data-bf-add-form]')) return;

      // ═══ FIX 4.0 : Détecter quel bouton a été cliqué ═══
      const submitter = e.submitter || document.activeElement;

      // Si le bouton submitter a name="checkout" ou la classe buynow → laisser passer (Shopify gère)
      if (submitter && (submitter.name === 'checkout' || submitter.classList.contains('bf-pdp-buynow-btn') || submitter.classList.contains('shopify-payment-button'))) {
        // Ne PAS intercepter — Shopify va ajouter le produit + rediriger vers /checkout
        return;
      }

      e.preventDefault();
      const formData = new FormData(form);
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Ajout en cours...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/javascript' },
        body: formData
      })
      .then(r => r.json())
      .then(data => {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Erreur d\'ajout');
        }
        if (submitBtn) {
          submitBtn.textContent = '✓ Ajouté au panier';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }
        bfToast(`${data.product_title || 'Produit'} ajouté au panier`, 'success');

        // FIX 3.0 : Refresh COMPLET du drawer puis ouverture
        refreshCartDrawer().then(() => {
          if (window.bfCartOpen) {
            setTimeout(() => window.bfCartOpen(), 300);
          }
        });
      })
      .catch(err => {
        if (submitBtn) {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }
        bfToast(err.message || 'Erreur, réessayez', 'error');
      });
    });
  }
/* ═══════════════════════════════════════════════════════
     6. UPSELL DRAWER (FIX 3.0)
     ═══════════════════════════════════════════════════════ */
  window.bfAddUpsell = function(variantId, button) {
    if (!variantId) return;

    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Ajout...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(data => {
      bfToast('Produit ajouté au panier', 'success');
      // Refresh complet du drawer
      return refreshCartDrawer();
    })
    .catch(err => {
      if (button) {
        button.textContent = original;
        button.disabled = false;
      }
      bfToast('Erreur, réessayez', 'error');
    });
  };
  
  /* ═══════════════════════════════════════════════════════
     7. EXIT INTENT POPUP
     ═══════════════════════════════════════════════════════ */
  const EXIT_POPUP_KEY = 'bf_exit_popup_shown';
  const EXIT_POPUP_DELAY_DAYS = 7;

  function shouldShowExitPopup() {
    try {
      const last = localStorage.getItem(EXIT_POPUP_KEY);
      if (!last) return true;
      const daysSince = (Date.now() - parseInt(last, 10)) / (1000 * 60 * 60 * 24);
      return daysSince >= EXIT_POPUP_DELAY_DAYS;
    } catch (e) { return true; }
  }

  function markExitPopupShown() {
    try { localStorage.setItem(EXIT_POPUP_KEY, Date.now().toString()); }
    catch (e) {}
  }

  function initExitPopup() {
    const popup = $('#bfExitPopup, .bf-exit-popup');
    if (!popup) return;

    let triggered = false;

    const show = () => {
      if (triggered || !shouldShowExitPopup()) return;
      triggered = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      markExitPopupShown();
    };

    const hide = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
    };

    // Desktop : mouvement souris vers le haut
    if (window.matchMedia('(min-width: 990px)').matches) {
      let mouseLeaveCount = 0;
      document.addEventListener('mouseleave', (e) => {
        if (e.clientY < 10) {
          mouseLeaveCount++;
          if (mouseLeaveCount >= 1) show();
        }
      });
    } else {
      // Mobile : scroll up rapide après scroll significatif
      let lastScroll = window.scrollY;
      let scrollUpDistance = 0;
      window.addEventListener('scroll', () => {
        const current = window.scrollY;
        if (current < lastScroll) {
          scrollUpDistance += (lastScroll - current);
          if (scrollUpDistance > 400 && current < 500 && lastScroll > 1500) {
            show();
          }
        } else {
          scrollUpDistance = 0;
        }
        lastScroll = current;
      }, { passive: true });

  // Déclenchement après 20 secondes sur la page
      setTimeout(show, 20000);
    }

    // Fermeture
    popup.querySelectorAll('[data-close], .bf-exit-popup-close, .bf-exit-popup-overlay').forEach(el => {
      el.addEventListener('click', hide);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) hide();
    });

    // Empêcher fermeture au clic dans la card
    const card = popup.querySelector('.bf-exit-popup-card');
    if (card) card.addEventListener('click', (e) => e.stopPropagation());
  }

  /* ═══════════════════════════════════════════════════════
     8. MOBILE STICKY ATC (fiches produits)
     ═══════════════════════════════════════════════════════ */
  function initMobileAtc() {
    const bar = $('.bf-mobile-atc');
    if (!bar) return;

    const productForm = $('product-form, .product-form, form[action*="/cart/add"]');
    if (!productForm) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && window.scrollY > 400) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -100px 0px' });

    observer.observe(productForm);

    // Cliquer sur le bouton mobile = scroll vers form + click submit
    const btn = bar.querySelector('.bf-mobile-atc-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => {
          const submit = productForm.querySelector('[type="submit"]');
          if (submit) submit.click();
        }, 600);
      });
    }
  }

  /* ═══════════════════════════════════════════════════════
     9. SCROLL REVEAL ANIMATIONS
     ═══════════════════════════════════════════════════════ */
  function initScrollReveal() {
    const elements = $$('.bf-reveal');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -80px 0px' });

    elements.forEach(el => observer.observe(el));
  }

  /* ═══════════════════════════════════════════════════════
     10. TOAST NOTIFICATIONS
     ═══════════════════════════════════════════════════════ */
  window.bfToast = function(message, type = 'success', duration = 3000) {
    const existing = $('.bf-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = `bf-toast bf-toast--${type}`;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    const icon = type === 'success' ? '✓' : '!';
    toast.innerHTML = `<span style="font-weight:600;color:var(--caramel);font-size:16px;">${icon}</span> <span>${message}</span>`;

    document.body.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('is-visible'));

    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    }, duration);
  };

  /* ═══════════════════════════════════════════════════════
     11. BURGER MENU MOBILE
     ═══════════════════════════════════════════════════════ */
  function initBurgerMenu() {
    const burger = $('.bf-burger');
    const nav = $('.bf-nav');
    if (!burger || !nav) return;

    burger.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Fermer en cliquant sur un lien
    nav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        nav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     12. SMOOTH SCROLL ANCHORS
     ═══════════════════════════════════════════════════════ */
  function initSmoothScroll() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (href === '#' || href === '') return;

      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      const offset = 80; // Hauteur header sticky
      const y = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* ═══════════════════════════════════════════════════════
     13. NEWSLETTER FORM
     ═══════════════════════════════════════════════════════ */
  function initNewsletterForm() {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches('.bf-newsletter-form, form[data-bf-newsletter]')) return;
      // Laisse Shopify gérer la soumission native
      // mais affiche un toast après succès
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        const original = btn.textContent;
        btn.textContent = 'Envoi...';
        setTimeout(() => {
          btn.textContent = '✓ Inscrit !';
bfToast('Merci ! Ton guide arrive dans ta boîte mail 🎁', 'success', 5000);
          setTimeout(() => { btn.textContent = original; }, 3000);
        }, 800);
      }
    });
  }

  /* ═══════════════════════════════════════════════════════
     14. INTERCEPTEUR FETCH (mise à jour panier auto)
     ═══════════════════════════════════════════════════════ */
function interceptCartActions() {
    // Ne PAS intercepter sur la page /cart native : Dawn (cart.js) gère déjà
    // le recalcul du total. Une double requête provoque l'erreur d'actualisation.
    if (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart')) {
      return;
    }

    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      const isCartAction = url.includes('/cart/add') ||
                          url.includes('/cart/change') ||
                          url.includes('/cart/update');

      return originalFetch.apply(this, args).then(response => {
        if (isCartAction && response.ok) {
          setTimeout(() => {
            try { updateShippingBar(); } catch (e) {}
          }, 350);
        }
        return response;
      });
    };
  }

  /* ═══════════════════════════════════════════════════════
     15. PRODUIT — VARIANT SELECTOR (changement de variante)
     ═══════════════════════════════════════════════════════ */
  function initVariantSelector() {
    $$('select[name="id"], input[name="id"]').forEach(selector => {
      selector.addEventListener('change', function() {
        const variantId = this.value;
        if (!variantId) return;

        const form = this.closest('form');
        if (!form) return;

        // Charger les infos de la variante via Shopify
        const productHandle = form.dataset.productHandle || window.location.pathname.split('/').pop();

        fetch(`/products/${productHandle}.js`)
          .then(r => r.json())
          .then(product => {
            const variant = product.variants.find(v => v.id == variantId);
            if (!variant) return;

            // Mettre à jour le prix
            const priceEl = form.querySelector('.bf-prod-price, [data-price]');
            if (priceEl) priceEl.textContent = formatMoney(variant.price);

            // Mettre à jour la disponibilité
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn) {
              if (variant.available) {
                submitBtn.disabled = false;
                submitBtn.textContent = submitBtn.dataset.textAvailable || 'Ajouter au panier';
              } else {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Rupture de stock';
              }
            }

            // Mettre à jour l'image si la variante en a une
            if (variant.featured_image) {
              const mainImg = $('.bf-product-img-main, [data-product-main-image]');
              if (mainImg) mainImg.src = variant.featured_image.src;
            }
          })
          .catch(err => console.warn('[Beautyfull] Variant fetch failed:', err));
      });
    });
  }

  /* ═══════════════════════════════════════════════════════
     16. ACCORDIONS (FAQ, descriptions produit)
     ═══════════════════════════════════════════════════════ */
  function initAccordions() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.bf-acc-trigger, [data-bf-accordion]');
      if (!trigger) return;

      const item = trigger.closest('.bf-acc-item, details');
      if (!item) return;

      // Si details natif, laisser le browser gérer
      if (item.tagName === 'DETAILS') return;

      const isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);

      const content = item.querySelector('.bf-acc-content');
      if (content) {
        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0';
        }
      }
    });
  }

  /* ═══════════════════════════════════════════════════════
     17. INIT (orchestration)
     ═══════════════════════════════════════════════════════ */
  function init() {
    updateShippingBar();
    initCartDrawer();
    attachCartItemEvents();
    initAddToCart();
    initExitPopup();
    initMobileAtc();
    initScrollReveal();
    interceptCartActions();
    initBurgerMenu();
    initSmoothScroll();
    initNewsletterForm();
    initVariantSelector();
    initAccordions();
    console.log('[Beautyfull] Initialized ✓');
  }

// Sur la page /cart native, on laisse Dawn gérer entièrement le panier.
  // beautyfull.js ne s'initialise PAS ici pour éviter les conflits de total.
  var bfIsCartPage = (window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart'));

  if (!bfIsCartPage) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  // Réinitialiser après changement Shopify section (éditeur thème)
  document.addEventListener('shopify:section:load', () => {
    initScrollReveal();
    initMobileAtc();
    attachCartItemEvents();
    initVariantSelector();
    updateShippingBar();
  });

  // Quand le panier est mis à jour côté Shopify (autres apps)
  document.addEventListener('cart:updated', () => {
    updateShippingBar();
    refreshCartDrawer();
  });

})();